(function ($) {

  
	$(document).ready(function () {



		if ($('#gallery_category').length ){

			if ( $( "#gallery_category" ).val() != '0' || $( "#eventyear" ).val() != '0'){
				$('.selected-filters').append('Επιλεγμένα φίλτρα > &nbsp;&nbsp;');
			}

			if ($( "#gallery_category" ).val() != '0'){
				$selected_gal_cat =  $( "#gallery_category option:selected" ).text();

				$('.selected-filters').append('Κατηγορία: ');
				$('.selected-filters').append('<strong>' + $selected_gal_cat  + '</strong> | ');
				$('#clear-filters').removeClass('d-none');
			}
			if ($( "#eventyear" ).val() != '0'){
				$selected_gal_year =  $( "#eventyear option:selected" ).text();
				$('.selected-filters').append( 'Έτος: ' );
				$('.selected-filters').append('<strong>' +  $selected_gal_year + '</strong>  ');
				$('#clear-filters').removeClass('d-none');
			}

			$('#clear-filters').on('click', function(e){
					e.preventDefault();
					window.location = window.location.href.split("?")[0];
			});

			// $('#gallery-filters select').select2({
			// 	theme: 'bootstrap4',
			// });
		}


		//auto submit forms 
		$('.widget-categories input[type=radio]').click(function() {
			$("#category-select").submit();
		});
		
		$('#theme, #location, #actions').change(function() {
			$("#category-select").submit();
		});	

		$('#select-year').change(function() {
			$("#year-form").submit();
		});	

		$('#select-calendar').change(function() {
			$("#go_to_cal").click();
		});	


		$('.newsletter-policy').click(function(e) {

			e.preventDefault();
			$.ajax({
			url: 'http://stasinopoulos.linux.greekgeeks.com/wp-json/wp/v2/pages/4327',
			dataType: 'json',
			success: function(data) {

				if( !$('#myModal').length ){
					console.log('modal appended to body');
					modal  =  '<div class="modal" id="myModal"><div class="modal-dialog"><div class="modal-content">' +
					'<div class="modal-header"><h4 class="modal-title">Modal Heading</h4><button type="button" class="close" data-dismiss="modal">&times;</button></div>' +
					'<div class="modal-body"></div>' +
					'</div></div></div>';
					$('body').append(modal);
				}

				$('#myModal .modal-title').html('').append(data.title.rendered);
				$('#myModal .modal-body').html('').append(data.content.rendered);
				$('#myModal').modal('show');

			},
		   statusCode: {
			  404: function() {
				alert('There was a problem with the server.  Try again soon!');
			  }
			}
		 });
	   });
	   
	   


	});

    
})(jQuery);



